const renderLogoCarousel = e => {

    const logoCarouselSections = document.querySelectorAll('.js-logo-carousel .swiper');

    if (logoCarouselSections.length) {
        logoCarouselSections.forEach(slider => {
            const swiper = new Swiper(slider, {
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false
                },
                loop: true,
                freeMode: true,
                speed: 3000,
                slidesPerView: 'auto',
                spaceBetween: 8
            });
        });
    }
}

const renderCorporateGallery = e => {
    
    const corpGallerySection = document.querySelectorAll('.js-corporate-gallery .swiper');

    if (corpGallerySection.length) {
        corpGallerySection.forEach(slider => {
            const swiper = new Swiper(slider, {
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 24,
                freeMode: true,
                navigation: {
                    nextEl: '.js-corporate-gallery .js-swiper-next',
                    prevEl: '.js-corporate-gallery .js-swiper-prev',
                    enabled: true
                },
                scrollbar: {
                    el: '.js-corporate-gallery .swiper-scrollbar',
                    draggable: true,
                    enabled: true
                },
            });
        });
    }
}

const renderCustomQuoteProductsCarousel = e => {
    
    const customQuoteCarouselSection = document.querySelectorAll('.js-custom-quote-products-carousel .swiper');

    if (customQuoteCarouselSection.length) {
        customQuoteCarouselSection.forEach(slider => {
            const swiper = new Swiper(slider, {
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 16,
                freeMode: true,
                navigation: {
                    nextEl: '.js-custom-quote-products-carousel .js-swiper-next',
                    prevEl: '.js-custom-quote-products-carousel .js-swiper-prev',
                    enabled: true
                },
                scrollbar: {
                    el: '.js-custom-quote-products-carousel .swiper-scrollbar',
                    draggable: true,
                    enabled: true
                }
            });
        });
    }
}

const renderCustomQuoteFormSlider = e => {
    
    const mainSlide = document.querySelector('.js-custom-quote-form-slider .swiperMain');
    const thumbSlide = document.querySelector('.js-custom-quote-form-slider .swiperThumb');
    
    if (mainSlide !== undefined && mainSlide !== null) {
        const swiperThumb = new Swiper(thumbSlide, {
            spaceBetween: 11,
            freeMode: true,
            slidesPerView: 'auto',
            watchSlidesProgress: true,
        });

        const swiper = new Swiper(mainSlide, {
            loop: false,
            freeMode: false,
            spaceBetween: 12,
            navigation: {
                nextEl: '.js-custom-quote-form-slider .js-swiper-next',
                prevEl: '.js-custom-quote-form-slider .js-swiper-prev',
                enabled: true
            },
            scrollbar: {
                el: '.js-custom-quote-form-slider .swiper-scrollbar',
                draggable: true,
                enabled: true
            },
            thumbs: {
                swiper: swiperThumb
            }
        });
    }
}

const renderTestimonialSlider = e => {

    const testimonialsSlider = document.querySelectorAll('.js-testimonials .swiper');

    if (testimonialsSlider.length) {
        testimonialsSlider.forEach(slider => {
            const swiper = new Swiper(slider, {
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 16,
                freeMode: true,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: '.js-testimonials .js-swiper-next',
                    prevEl: '.js-testimonials .js-swiper-prev',
                    enabled: true
                },
                scrollbar: {
                    el: '.js-testimonials .swiper-scrollbar',
                    draggable: true,
                    enabled: true
                },
                breakpoints: {
                    0: {
                        autoHeight: true,
                    },
                    767: {
                        autoHeight: false
                    }
                }
            });
        });
    }
}

const renderFontSlider = () => {
    const fontSlider = document.querySelectorAll('.js-form-slider');

    if (fontSlider.length) {
        fontSlider.forEach(slider => {
            const swiper = new Swiper(slider, {
                loop: false,
                spaceBetween: 16,
                slidesPerView: 'auto',
                freeMode: true,
                autoHeight: false,
                navigation: {
                    nextEl: '.js-form-slider .js-swiper-next',
                    prevEl: '.js-form-slider .js-swiper-prev',
                    enabled: true
                }
            });
        });
    }
}

const initNavigation = e => {
    const parentNavItems = document.querySelectorAll('.js-parent-nav');
    const mobileNavTrigger = document.querySelector('.js-mobile-nav-trigger');
    const mobileCloseNav = document.querySelectorAll('.js-sub-nav-back');

    if (parentNavItems !== undefined && parentNavItems !== null) {
        parentNavItems.forEach(item => {
            item.addEventListener('mouseenter', e => {
                if (window.innerWidth >= 991) {
                    document.body.classList.add('parent-nav-hover');
                    e.currentTarget.classList.add('active-child');
                }
            });

            item.addEventListener('mouseleave', e => {
                if (window.innerWidth >= 991) {
                    document.body.classList.remove('parent-nav-hover');
                    e.currentTarget.classList.remove('active-child');
                }
            });

            item.addEventListener('click', e => {
                const fromRight = window.innerWidth - e.clientX;
                const rightLocation = e.currentTarget.getBoundingClientRect().right - e.clientX;
                // console.log(rightLocation);
                
                if (fromRight <= 50 && window.innerWidth <= 1149) {
                    e.preventDefault();
                    document.body.classList.add('sub-nav-open');
                    
                    document.querySelector(`.navigation__item-child.${e.target.dataset.child}`).classList.add('nav-active');
                } else if(window.innerWidth >= 1150 && rightLocation <= 30 && rightLocation >= 0) {
                    // console.log(e.currentTarget.closest('.sub-navigation'));
                    if (!e.currentTarget.closest('.sub-navigation')) {
                        e.preventDefault();
                    }

                    if (e.currentTarget.classList.contains('active-child')) {
                        e.currentTarget.classList.remove('active-child');
                        document.body.classList.remove('parent-nav-hover');
                    } else {
                        parentNavItems.forEach(item => {
                            item.classList.remove('active-child');
                        });

                        e.currentTarget.classList.add('active-child');
                        document.body.classList.add('parent-nav-hover');
                    }
                }
            });
        });
    }

    if (mobileNavTrigger !== undefined && mobileNavTrigger !== null) {
        mobileNavTrigger.addEventListener('click', e => {
            e.preventDefault();
            if (document.body.classList.contains('mobile-nav-active')) {
                document.body.classList.remove('mobile-nav-active');
            } else {
                document.body.classList.add('mobile-nav-active');
            }
        });
    }

    if (mobileCloseNav !== undefined && mobileCloseNav !== null) {
        mobileCloseNav.forEach(button => {
            button.addEventListener('click', e => {
                e.preventDefault();
                document.body.classList.remove('sub-nav-open');
                document.querySelector('.navigation__item-child.nav-active').classList.remove('nav-active');
            });
        });
    }
}

const initAccordion = e => {
    const accordionItems = document.querySelectorAll('.js-accordion-item');

    if (accordionItems.length) {
        accordionItems.forEach(item => {
            item.addEventListener('click', e => {
                if (e.currentTarget.classList.contains('active-acordion')) {
                    e.currentTarget.classList.remove('active-acordion');
                } else {
                    accordionItems.forEach(item => {
                        item.classList.remove('active-acordion');
                    });
                    e.currentTarget.classList.add('active-acordion');
                }
            });
        });
    }
}

const initFAQTab = e => {
    const tabHeading = document.querySelectorAll('.js-faq-tab-head');
    const tabContent = document.querySelectorAll('.js-faq-content');

    if (tabHeading.length) {
        tabHeading.forEach(item => {
            item.addEventListener("click", e => {
                if (!e.currentTarget.classList.contains('active')) {
                    tabContent.forEach(content => {
                        content.classList.remove('active');
                    });
                    
                    tabHeading.forEach(headingContainer => {
                        headingContainer.classList.remove('active');
                    });

                    e.currentTarget.classList.add('active');

                    document.querySelector(`.js-faq-content.faq-section__section--${e.currentTarget.dataset.tab}`).classList.add('active');
                }
            })
        });
    }
}

const initVideoPlayer = e => {
    const videoPlayers = document.querySelectorAll('.js-video-player');

    if (videoPlayers) {
        videoPlayers.forEach(container => {
            // find the video inside the container
            const video = container.querySelector("video");
            // console.log(video);
            if (!video) return;

            // create controls wrapper
            const controls = document.createElement("div");
            controls.classList.add("video-controls");

            // create buttons
            const playBtn = document.createElement("div");
            playBtn.classList.add('video-button', 'video-button--play');
            playBtn.textContent = "Play";

            // const pauseBtn = document.createElement("div");
            // pauseBtn.textContent = "Pause";

            const stopBtn = document.createElement("div");
            stopBtn.classList.add('video-button', 'video-button--stop');
            stopBtn.textContent = "Stop";

            // append buttons to controls
            controls.appendChild(playBtn);
            // controls.appendChild(pauseBtn);
            controls.appendChild(stopBtn);

            // add controls to container
            container.appendChild(controls);

            // functionality
            playBtn.addEventListener("click", () => {
                video.play();
                container.classList.add("playing");
            });

            // pauseBtn.addEventListener("click", () => {
            //     video.pause();
            // });

            stopBtn.addEventListener("click", () => {
                container.classList.remove("playing");
                video.pause();
                video.currentTime = 0; // reset to start
            });

            video.addEventListener("ended", () => {
                container.classList.remove("playing");
            });
        });
    }
}

// Commented out - now using server-side Liquid rendering for SEO
/* const initProductListing = () => {
    const container = document.querySelector('.js-product-listing');
    const paginationContainer = document.querySelector('.js-product-listing-pagination');
    if (!container) return;

    const collectionHandle = container.getAttribute('data-handle');
    const perPage = parseInt(container.getAttribute('data-per-page'), 10) || 12;
    const totalProducts = parseInt(container.getAttribute('data-total-product')) || 50;

    let products = [];
    let currentPage = 1;
    let totalPages = 1;

    // --- Detect ?page= from URL ---
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = parseInt(urlParams.get('page'), 10);
    if (!isNaN(pageParam) && pageParam > 0) {
        currentPage = pageParam;
    }

    const paginationControls = document.createElement('nav');
    paginationControls.className = 'pagination-controls';

    const prevLink = document.createElement('a');
    prevLink.textContent = 'Previous';
    prevLink.href = '#';

    const nextLink = document.createElement('a');
    nextLink.textContent = 'Next';
    nextLink.href = '#';

    const numberContainer = document.createElement('div');
    numberContainer.className = 'pagination-numbers';

    paginationControls.appendChild(prevLink);
    paginationControls.appendChild(numberContainer);
    paginationControls.appendChild(nextLink);

    // Fetch products
    fetch(`/collections/${collectionHandle}/products.json?limit=${totalProducts}`)
        .then(response => response.json())
        .then(data => {
            products = data.products;
            if (!products || products.length === 0) {
                container.innerHTML = '<p>No products found in this collection.</p>';
                return;
            }

            totalPages = Math.ceil(products.length / perPage);
            currentPage = Math.min(currentPage, totalPages);

            renderPage(currentPage);
            paginationContainer.appendChild(paginationControls);
            updatePaginationLinks();
            renderNumberedPagination();
        })
        .catch(error => {
            console.error('Error fetching products:', error);
            container.innerHTML = '<p>Failed to load products.</p>';
        });

    // --- Pagination navigation ---
    prevLink.addEventListener('click', (e) => {
        e.preventDefault();
        changePage(currentPage - 1, true);
    });
    nextLink.addEventListener('click', (e) => {
        e.preventDefault();
        changePage(currentPage + 1, true);
    });

    function changePage(pageNum, scroll = false) {
        if (pageNum < 1 || pageNum > totalPages) return;
        currentPage = pageNum;

        renderPage(currentPage);
        updatePaginationLinks();
        renderNumberedPagination();

        // Update URL for sharing
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('page', currentPage);
        window.history.pushState({ page: currentPage }, '', newUrl);

        if (scroll) scrollToTop();
    }

    function renderPage(page) {
        container.innerHTML = '';
        paginationContainer.appendChild(paginationControls);

        const start = (page - 1) * perPage;
        const end = start + perPage;
        const pageProducts = products.slice(start, end);

        pageProducts.forEach(product => {
            const productCard = document.createElement('div');
            productCard.className = 'product-listing-card js-clickable-card round-20';

            const wrap = document.createElement('div');
            wrap.className = 'product-listing-card__wrap';

            // Badge
            if (product.tags && product.tags.includes('Best Seller')) {
                const badgeWrap = document.createElement('div');
                badgeWrap.className = 'product-listing-card__badge';
                const badgeItem = document.createElement('div');
                badgeItem.className = 'product-listing-card__badge-item';
                badgeItem.textContent = 'Best Seller';
                badgeWrap.appendChild(badgeItem);
                wrap.appendChild(badgeWrap);
            }

            // Image
            const imageDiv = document.createElement('div');
            imageDiv.className = 'product-listing-card__image';

            const img = document.createElement('img');
            const imageSrc = product?.images?.[0]?.src ? product.images[0].src.replace(/(\.[^.]*)$/, '_400x$1') : '//ties-n-cuffs-staging.myshopify.com/cdn/shop/t/2/assets/sample-product-image.png';
            img.src = imageSrc;
            img.alt = product.title;
            imageDiv.appendChild(img);
            wrap.appendChild(imageDiv);

            // Content
            const contentDiv = document.createElement('div');
            contentDiv.className = 'product-listing-card__content';

            // Stats
            const statsDiv = document.createElement('div');
            statsDiv.className = 'product-listing-card__stats';

            // Feefo collection reviews
            const productSku = product.variants?.[0]?.sku || '';
            const statsRight = document.createElement('div');
            statsRight.className = 'product-listing-card__stats-right';
            if (productSku) {
                statsRight.innerHTML = `
                    <img class="collection-reviews" alt="Feefo product rating" src="https://api.feefo.com/api/logo?merchantidentifier=ties-n-cuffs&vendorref=${productSku}&smallonzero=true&since=all" title="Our Feefo product rating"/>
                `;
            }

            statsDiv.appendChild(statsRight);

            // Title
            const titleDiv = document.createElement('div');
            titleDiv.className = 'product-listing-card__title';
            const titleLink = document.createElement('a');
            titleLink.href = `/products/${product.handle}`;
            const titleH6 = document.createElement('h6');
            titleH6.textContent = product.title;
            titleLink.appendChild(titleH6);
            titleDiv.appendChild(titleLink);

            // Price
            const priceDiv = document.createElement('div');
            priceDiv.className = 'product-listing-card__price';
            const variant = product.variants?.[0];
            if (variant) {
                // const price = (variant.price / 100).toFixed(2);
                // console.log(variant.price);
                priceDiv.innerHTML = `<span class="lg-body">$ ${variant.price} AUD</span> <span class="sm-body">INC. GST</span>`;
            }

            contentDiv.appendChild(statsDiv);
            contentDiv.appendChild(titleDiv);
            contentDiv.appendChild(priceDiv);

            wrap.appendChild(contentDiv);
            productCard.appendChild(wrap);

            container.appendChild(productCard);
        });
    }

    function updatePaginationLinks() {
        prevLink.href = currentPage > 1 ? `?page=${currentPage - 1}` : '#';
        nextLink.href = currentPage < totalPages ? `?page=${currentPage + 1}` : '#';
        prevLink.classList.toggle('disabled', currentPage === 1);
        nextLink.classList.toggle('disabled', currentPage === totalPages);
    }

    function renderNumberedPagination() {
        numberContainer.innerHTML = '';

        const maxVisible = 5;
        let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let end = Math.min(totalPages, start + maxVisible - 1);
        if (end - start < maxVisible - 1) {
            start = Math.max(1, end - maxVisible + 1);
        }

        if (start > 1) {
            const first = createPageLink(1);
            numberContainer.appendChild(first);
            if (start > 2) {
                const dots = document.createElement('span');
                dots.textContent = '...';
                numberContainer.appendChild(dots);
            }
        }

        for (let i = start; i <= end; i++) {
            const link = createPageLink(i);
            if (i === currentPage) link.classList.add('active');
            numberContainer.appendChild(link);
        }

        if (end < totalPages) {
            if (end < totalPages - 1) {
                const dots = document.createElement('span');
                dots.textContent = '...';
                numberContainer.appendChild(dots);
            }
            const last = createPageLink(totalPages);
            numberContainer.appendChild(last);
        }
    }

    function createPageLink(pageNum) {
        const link = document.createElement('a');
        link.href = `?page=${pageNum}`;
        link.textContent = pageNum;
        link.className = 'page-number';
        link.addEventListener('click', (e) => {
            e.preventDefault();
            changePage(pageNum, true);
        });
        return link;
    }

    function scrollToTop() {
        container.scrollIntoView({ behavior: 'smooth' });
    }

    // --- Handle browser back/forward ---
    window.addEventListener('popstate', (event) => {
        const page = event.state?.page || 1;
        currentPage = page;
        renderPage(currentPage);
        updatePaginationLinks();
        renderNumberedPagination();
    });
} */

const initTabs = e => {
    const tabHeadings = document.querySelectorAll('.js-tab-heading');
    const tabItems = document.querySelectorAll('.tabs-item');

    tabHeadings.forEach(heading => {
        heading.addEventListener('click', event => {
            event.preventDefault();

            const target = heading.getAttribute('data-content');

            // Remove 'active' from all headings
            tabHeadings.forEach(h => h.classList.remove('active'));

            // Add 'active' to clicked heading
            heading.classList.add('active');

            // Remove 'active' from all tab items
            tabItems.forEach(item => item.classList.remove('active'));

            // Add 'active' to matching tab item
            const targetTab = document.querySelector(`.tabs-item.${target}`);
            if (targetTab) {
                targetTab.classList.add('active');
            }
        });
    });

}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function formatMoney(cents, currency = 'AUD') {
    return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: currency
    }).format(cents / 100);
}

function renderTwoDecimal(val) {
    const price = val.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    
    return price;
}

function getTotalPrice(origPrice, qty, abp, totalContainer) {
    let totalPrice = origPrice;
    totalPrice = totalPrice * qty;
    
    if (abp) {
        totalPrice += 5;
    }

    totalContainer.innerHTML = `$ ${renderTwoDecimal(totalPrice)} AUD`;

    totalContainer.classList.add('single-product-total--changed');

    const priceContainers = document.querySelectorAll('.js-price');
    if (priceContainers.length) {

        priceContainers.forEach(container => {
            container.innerHTML = `$ ${renderTwoDecimal(totalPrice)} AUD`;
        });
    }
}

function updateQtyField(fieldContainer, value) {
    if (fieldContainer !== null && fieldContainer !== undefined) {
        fieldContainer.innerHTML = value
    }
}

function updateAdditionalFields(data) {
    const container = document.querySelector('.js-sp-additional-fields');
    const mobileContainer = document.querySelector('.js-sp-additional-fields-mb');

    container.innerHTML = "";
    mobileContainer.innerHTML = "";

    const parentWrapper = document.createElement('div');
    parentWrapper.className = 'single-product__additional-fields-overlay';

    const parentWrapperMb = document.createElement('div');
    parentWrapperMb.className = 'single-product__additional-fields-overlay';


    const parentInnerWrapper = document.createElement('div');
    parentInnerWrapper.className = 'single-product__additional-fields-overlay-inner';

    let count = 0;

    for (const [key, value] of Object.entries(data)) {
        if (key == "totalPrice") continue;

        const itemWrapper = document.createElement('div');
        itemWrapper.className = 'additional-item';
        
        const itemWrapperMb = document.createElement('div');
        itemWrapperMb.className = 'additional-item';

        let displayValue;

        // Check if value is a File
        if (value instanceof File) {
            displayValue = `${value.name} (${Math.round(value.size / 1024)} KB)`;
        } else {
            displayValue = value;
        }

        if (key == "Artwork Before Work") {
            displayValue = value ? "Yes" : "No";   
        }

        itemWrapper.innerHTML = `
            <strong>${key}:</strong> ${displayValue}
        `;

        itemWrapperMb.innerHTML = `
            <strong>${key}:</strong> ${displayValue}
        `;

        if (count < 3) {
            container.appendChild(itemWrapper);
        } else {
            parentInnerWrapper.appendChild(itemWrapper);
        }

        parentWrapperMb.appendChild(itemWrapperMb);


        count++;
    }

    mobileContainer.appendChild(parentWrapperMb);

    // Append the grouped items (4th and beyond) at the end
    if (parentInnerWrapper.children.length > 0) {
        const extraCounter = document.createElement('span');
        extraCounter.innerHTML = `+ ${parentInnerWrapper.children.length}`;
        parentWrapper.appendChild(extraCounter);
        parentWrapper.appendChild(parentInnerWrapper);
        container.appendChild(parentWrapper);
    }
}

function invalidInput(inputElem, errorMessage, errorCount) {
    const inputLabel = inputElem.closest("label");
    const message = document.createElement("p");
    message.classList.add("input-error-message");
    message.innerText = errorMessage;

    inputLabel.classList.add('error');

    if (errorCount === 1) {

        inputElem.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
        });
        inputElem.focus();
    }
    
    if (inputLabel.querySelector(".input-error-message") !== null && inputLabel.querySelector(".input-error-message") !== undefined) {
        return;
    }

    inputLabel.appendChild(message);
}

function valueInput(inputElem) {
    const inputLabel = inputElem.closest("label");
    inputLabel.classList.remove('error');
}

const initSingleProduct = () => {
    const singleProductContainer = document.querySelector('.js-single-product');

    if (singleProductContainer !== null && singleProductContainer !== undefined) {
        const productPrice = document.querySelector('.js-original-price').dataset.price || 0;
        const totalContainer = document.querySelector('.js-single-product-total');
        const qtyContainer = document.querySelector('.js-input-quantity');
        const engravingText = document.querySelector('.js-input-engraving-text') || "";
        const rdoArtworkBeforeProd = document.querySelectorAll('.js-input-before-rod');
        const rdoDeliverySpeed = document.querySelectorAll('.js-input-delivery-speed');
        const minimumQty = document.querySelector('.js-minimum-quantity').dataset.minimum || 1;
        const fontField = document.querySelectorAll('.js-rdo-font');
        const assetUpload = document.querySelector('.js-asset-upload');
        const specialInstruction = document.querySelector('.js-special-instruction');
        const toggleOrderDetails = document.querySelector('.js-toggle-order-details') || "";
        const metalPlatingFinish = document.querySelectorAll('.js-rdo-metal-plating-finish');
        const packagings = document.querySelectorAll('.js-rdo-packaging');
        const backFittings = document.querySelectorAll('.js-rdo-back-fitting');
        const customSize = document.querySelector('.js-custom-size') || "";
        const inputSizes = document.querySelectorAll('.js-rdo-size');
        const optionalAddOns = document.querySelectorAll('.js-rdo-optional-addons');
        let totalPrice = parseFloat(productPrice); // Add additional prices to this
        let addedBeforeWork = false;
        let qty = minimumQty;
        let additionalFields = [];
        let addedPackaging = 0;
        let addedBackFitting = 0
        let addOns = 0;
        

        additionalFields["Quantity"] = minimumQty;
        additionalFields["totalPrice"] = totalPrice;

        /*
        if (singleProductContainer.querySelector('form')) {
            const form = singleProductContainer.querySelector('form');
            const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
            
            if (submitButton && qtyContainer) {
                submitButton.addEventListener('click', e => {
                    const qtyValue = parseFloat(qtyContainer.value);
                    let errorCount = 0;

                    if (!qtyContainer.value || isNaN(qtyValue) || qtyValue < 100) {
                        e.preventDefault();
                        const errorMessage = `Minimum quantity should be ${minimumQty}`;
                        invalidInput(qtyContainer, errorMessage, ++errorCount);
                    } else {
                        valueInput(qtyContainer);
                    }

                    if (engravingText) {
                        if (!engravingText.value) {
                            e.preventDefault();
                            const errorMessage = `This field is required`;
                            invalidInput(engravingText, errorMessage, ++errorCount);
                        }
                    }
                });
            }
            
            if (qtyContainer) {
                qtyContainer.addEventListener('input', () => {
                    valueInput(qtyContainer);
                });
            }

            if (engravingText) {
                engravingText.addEventListener('input', () => {
                    valueInput(engravingText);
                });
            }
        }

        // On change of `Artwork Before Production` field
        if (rdoArtworkBeforeProd.length) {
            rdoArtworkBeforeProd.forEach(elem => {
                elem.addEventListener('change', e => {
                    if (e.target.value == "yes") {
                        additionalFields["totalPrice"] = totalPrice + 5;
                        additionalFields["Artwork Before Work"] = true;
                        addedBeforeWork = true;
                    } else {
                        if (addedBeforeWork) {
                            additionalFields["totalPrice"] -= 5;
                        }
                        additionalFields["Artwork Before Work"] = false;
                        addedBeforeWork = false
                    }
                    
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                    updateQtyField(qtyContainer, additionalFields["Quantity"]);
                    updateAdditionalFields(additionalFields);
                });
            });
        }

        // Delivery Speed
        if (rdoDeliverySpeed.length) {
            rdoDeliverySpeed.forEach(elem => {
                elem.addEventListener('change', e => {
                    if (e.target.value == "Express") {
                        additionalFields["totalPrice"] = totalPrice + 5;
                        additionalFields["Delivery Speed"] = "Express";
                    } else {
                        additionalFields["Delivery Speed"] = "Standard";
                    }

                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                    updateAdditionalFields(additionalFields);
                });
            });
        }

        // On change of qty field
        if (qtyContainer !== null && qtyContainer !== undefined) {
            qtyContainer.addEventListener("change", e => {
                additionalFields["Quantity"] = e.target.value;
                if (additionalFields["Quantity"] < 1) {
                    additionalFields["Quantity"] = minimumQty;
                }
                getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                updateQtyField(qtyContainer, additionalFields["Quantity"]);
                updateAdditionalFields(additionalFields);
            });
        }
        */

        // On change font field
        if (fontField.length) {
            fontField.forEach(field => {
                field.addEventListener("change", e => {
                    additionalFields["Font"] = e.target.value;
                    updateAdditionalFields(additionalFields);
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                });
            });
        }

        // Engraving Text
        if (engravingText) {
            engravingText.addEventListener('change', e => {
                additionalFields["Engraving Text"] = e.target.value;
                updateAdditionalFields(additionalFields);
                getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
            });
        }

        // File upload
        if (assetUpload !== null && assetUpload !== undefined) {
            assetUpload.addEventListener('change', e => {
                const file = e.target.files[0];
                if (file) {
                    additionalFields["File"] = file;
                    updateAdditionalFields(additionalFields);
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                }

            });
        }

        // Special instruction
        if (specialInstruction !== null && specialInstruction !== undefined) {
            specialInstruction.addEventListener('change', e => {
                if (e.target.value) {
                    additionalFields["Special Instruction"] = e.target.value;
                    updateAdditionalFields(additionalFields);
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                }
            });
        }

        if (toggleOrderDetails) {
            toggleOrderDetails.addEventListener("click", e => {
                const container = e.target.closest(".single-product__footer-mobile");
                
                if (container.classList.contains('show-meta')) {
                    container.classList.remove('show-meta');
                } else {
                    container.classList.add('show-meta');
                }
            });
        }

        // Metal Plating/Finish
        if (metalPlatingFinish.length) {
            metalPlatingFinish.forEach(field => {
                field.addEventListener("change", e => {
                    additionalFields["Metal Plating/Finish"] = e.target.value;
                    updateAdditionalFields(additionalFields);
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                });
            });
        }

        // Packaging
        if (packagings.length) {
            packagings.forEach(field => {
                field.addEventListener("change", e => {
                    // Remove old packaging price
                    totalPrice -= parseFloat(addedPackaging);

                    additionalFields["Packaging"] = e.target.value;
                    addedPackaging = e.target.dataset.price || 0;
                    
                    // Add new packaging price
                    totalPrice += parseFloat(addedPackaging);
                    updateAdditionalFields(additionalFields);
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                });
            });
        }

        // Back Fitting
        if (backFittings.length) {
            backFittings.forEach(field => {
                field.addEventListener("change", e => {
                    // Remove old Back Fitting price
                    totalPrice -= parseFloat(addedBackFitting);
                    
                    additionalFields["Back Fitting"] = e.target.value;
                    addedBackFitting = e.target.dataset.price || 0;
                    
                    // Add new Back Fitting price
                    totalPrice += parseFloat(addedBackFitting);

                    updateAdditionalFields(additionalFields);
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                });
            });
        }

        if (customSize) {
            customSize.addEventListener("change", e => {

                additionalFields["Approximate Size"] = e.target.value + "mm";
                updateAdditionalFields(additionalFields);
                getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);

                if (inputSizes.length) {
                    inputSizes.forEach(field => {
                        field.checked = false;
                    });
                }
            });
        }

        if (inputSizes.length) {
            inputSizes.forEach(field => {
                field.addEventListener("change", e => {
                    additionalFields["Approximate Size"] = e.target.value;
                    updateAdditionalFields(additionalFields);
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);

                    if (customSize) {
                        customSize.value = "";
                    }
                });
            });
        }

        if (optionalAddOns.length) {
            optionalAddOns.forEach(field => {
                field.addEventListener("change", e => {
                    // Remove old Back Fitting price
                    totalPrice -= parseFloat(addOns);

                    additionalFields["Optional Add-Ons"] = e.target.value;
                    addOns = e.target.dataset.price || 0;
                    
                    // Add new Back Fitting price
                    totalPrice += parseFloat(addOns);

                    updateAdditionalFields(additionalFields);
                    getTotalPrice(totalPrice, additionalFields["Quantity"], addedBeforeWork, totalContainer);
                });
            });
        }
    }
}

const cartInit = () => {
    const cartContainer = document.querySelector('.js-cart') || "";

    if (cartContainer) {
        const quantFields = document.querySelectorAll('.js-input-quantity');
        const showProperties = document.querySelectorAll('.js-show-order-details');

        // Quantity update with debounce
        if (quantFields.length) {
            quantFields.forEach(function (input) {
                const debouncedUpdate = debounce(function(inputEl) {
                    const newQty = parseInt(inputEl.value, 10);
                    const lineItemKey = inputEl.dataset.lineItemKey;

                    if (!lineItemKey || isNaN(newQty)) return;

                    // Add loading state
                    inputEl.disabled = true;
                    const cartItem = inputEl.closest('.cart-item');
                    if (cartItem) cartItem.classList.add('is-updating');

                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: lineItemKey,
                            quantity: newQty
                        })
                    })
                    .then(response => {
                        if (!response.ok) {
                            return response.json().then(err => Promise.reject(err));
                        }
                        return response.json();
                    })
                    .then(cart => {
                        if (!cart || !cart.items) {
                            console.error('Invalid cart response:', cart);
                            return;
                        }
                        // Update line item price
                        const lineItem = cart.items.find(item => item.key === lineItemKey);

                        if (lineItem && cartItem) {
                            const priceEl = cartItem.querySelector('.cart-item__product-price strong');
                            if (priceEl) {
                                priceEl.textContent = formatMoney(lineItem.line_price);
                            }
                        }

                        // Update cart totals
                        const subtotalEl = document.querySelector('.cart-summary__subtotal strong');
                        const totalEl = document.querySelector('.cart-summary__total h6');

                        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
                        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

                        // Handle item removal (qty = 0)
                        if (newQty === 0 && cartItem) {
                            cartItem.remove();
                            if (cart.item_count === 0) {
                                location.reload();
                            }
                        }
                    })
                    .catch(err => {
                        console.error('Failed to update cart:', err);

                        // Show user-friendly toast message
                        if (err && err.message) {
                            Toastify({
                                text: err.message,
                                duration: 4000,
                                gravity: "top",
                                position: "right",
                                style: {
                                    background: "#dc3545"
                                }
                            }).showToast();
                        }

                        // Fetch current cart state to sync UI with actual values
                        fetch('/cart.js')
                            .then(response => response.json())
                            .then(cart => {
                                if (!cart || !cart.items) return;

                                const lineItem = cart.items.find(item => item.key === lineItemKey);
                                if (lineItem) {
                                    // Update input to actual quantity
                                    inputEl.value = lineItem.quantity;

                                    // Update line item price
                                    if (cartItem) {
                                        const priceEl = cartItem.querySelector('.cart-item__product-price strong');
                                        if (priceEl) {
                                            priceEl.textContent = formatMoney(lineItem.line_price);
                                        }
                                    }
                                }

                                // Update cart totals
                                const subtotalEl = document.querySelector('.cart-summary__subtotal strong');
                                const totalEl = document.querySelector('.cart-summary__total h6');
                                if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
                                if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
                            });
                    })
                    .finally(() => {
                        inputEl.disabled = false;
                        if (cartItem) cartItem.classList.remove('is-updating');
                    });
                }, 500);

                input.addEventListener('change', function() {
                    debouncedUpdate(this);
                });

                input.addEventListener('input', function() {
                    debouncedUpdate(this);
                });
            });

        }

        // Remove item buttons
        const removeButtons = document.querySelectorAll('.js-cart-remove');
        if (removeButtons.length) {
            removeButtons.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    const lineItemKey = this.dataset.lineItemKey;
                    if (!lineItemKey) return;

                    const cartItem = this.closest('.cart-item');
                    if (cartItem) cartItem.classList.add('is-updating');

                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: lineItemKey,
                            quantity: 0
                        })
                    })
                    .then(response => response.json())
                    .then(cart => {
                        // Update cart totals
                        const subtotalEl = document.querySelector('.cart-summary__subtotal strong');
                        const totalEl = document.querySelector('.cart-summary__total h6');

                        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
                        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

                        // Update cart count in header
                        const cartCountHeader = document.querySelector('.js-cart h3');
                        if (cartCountHeader) cartCountHeader.textContent = `Your cart (${cart.item_count})`;

                        // Remove the item from DOM
                        if (cartItem) cartItem.remove();

                        // Reload if cart is empty
                        if (cart.item_count === 0) {
                            location.reload();
                        }
                    })
                    .catch(err => {
                        console.error('Failed to remove item:', err);
                        if (cartItem) cartItem.classList.remove('is-updating');
                    });
                });
            });
        }

        // Properties slider
        if (showProperties.length) {
            showProperties.forEach(item => {
                item.addEventListener('click', e => {
                    e.preventDefault();
                    const parentContainer = e.target.closest(".cart-item");

                    if (parentContainer.classList.contains("active-property")) {
                        parentContainer.classList.remove("active-property");
                    } else {
                        parentContainer.classList.add("active-property");
                    }
                });
            });
        }
    }
}

const customSelectInit = () => {
    const selects = document.querySelectorAll('select.js-custom-select');

    if (selects.length) {
        selects.forEach(originalSelect => {
            const options = Array.from(originalSelect.options);
            const selectedOption = originalSelect.options[originalSelect.selectedIndex];

            const customSelect = document.createElement('div');
            customSelect.className = 'custom-select-wrapper';

            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = originalSelect.name;
            hiddenInput.value = selectedOption.value;

            const selectedDiv = document.createElement('div');
            selectedDiv.className = 'custom-select-selected';
            selectedDiv.textContent = selectedOption.textContent || 'Please select';

            const optionsDiv = document.createElement('div');
            optionsDiv.className = 'custom-select-options';

            options.forEach(option => {
                const optionDiv = document.createElement('div');
                optionDiv.textContent = option.textContent;
                optionDiv.dataset.value = option.value;

                if (option.selected) {
                    optionDiv.classList.add('selected');
                }

                optionDiv.addEventListener('click', () => {
                    selectedDiv.textContent = option.textContent;
                    hiddenInput.value = option.value;

                    // Remove existing .selected class
                    optionsDiv.querySelectorAll('div').forEach(opt => opt.classList.remove('selected'));
                    optionDiv.classList.add('selected');

                    customSelect.classList.remove('open');
                });

                optionsDiv.appendChild(optionDiv);
            });


            selectedDiv.addEventListener('click', () => {
                const isOpen = customSelect.classList.contains('open');
                document.querySelectorAll('.custom-select-wrapper.open').forEach(el => el.classList.remove('open'));
                if (!isOpen) customSelect.classList.add('open');
            });

            document.addEventListener('click', (e) => {
                if (!customSelect.contains(e.target)) {
                    customSelect.classList.remove('open');
                }
            });

            customSelect.appendChild(hiddenInput);
            customSelect.appendChild(selectedDiv);
            customSelect.appendChild(optionsDiv);

            originalSelect.closest('label').replaceWith(customSelect);
        });

    }

}

const clickableCard = () => {
    document.addEventListener('click', e => {
        const card = e.target.closest('.js-clickable-card');

        if (!card) return; // not inside a clickable card
        if (e.target.tagName.toLowerCase() === 'a' || e.target.closest('button')) return; // ignore direct link/button clicks

        const link = card.querySelector('a');
        if (link && link.href) {
            if (link.target === '_blank') {
                window.open(link.href, '_blank');
            } else {
                window.location.href = link.href;
            }
        }
    });
}

const initInputFile = () => {
    const inputFiles = document.querySelectorAll('.js-input-file');

    if (inputFiles.length) {
        inputFiles.forEach(elem => {
            elem.addEventListener('change', e => {
                const inputContainer = e.target.closest("label") || "";
                const file = e.target.files[0];

                if (inputContainer && file) {
                    const textContainer = inputContainer.querySelector('span') || "";

                    if (textContainer) {
                        if (file) {
                            textContainer.innerText = `File name: ${file.name}`;
                        }
                    }
                }
            });
        });
    }
}

const initPopup = () => {
    const popups = document.querySelectorAll('.js-open-popup');
    const closePopups = document.querySelectorAll(".js-close-popup");

    if (popups.length) {
        popups.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();

                const thisPopup = document.querySelector(`.popup-container${e.target.hash}`) || "";

                if (thisPopup) {
                    thisPopup.classList.add("active");
                    document.body.classList.add("popup-open");
                }
            });
        });

        closePopups.forEach(item => {
            item.addEventListener("click", e => {
                e.preventDefault();
                document.querySelector(".popup-container.active").classList.remove("active");
                document.body.classList.remove("popup-open");
            });
        });
    }
}

async function getFeefoSummary(merchantId) {
    const feefoRateContainers = document.querySelectorAll(".js-feefo-badge-rate") || "";
    const feefoCountContainers = document.querySelectorAll(".js-feefo-badge-count") || "";

    if (![...feefoRateContainers, ...feefoCountContainers].length) return;

    const url = `https://api.feefo.com/api/10/reviews/summary/all?merchant_identifier=${merchantId}&since_period=all`;

    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    const rating = data.rating.rating;
    const total = data.rating.product.count;

    if (feefoRateContainers.length !== 0) {
        feefoRateContainers.forEach(elem => {
            elem.innerHTML = rating;
        });
    }

    if (feefoCountContainers.length !== 0) {
        feefoCountContainers.forEach(elem => {
            elem.innerHTML = total;
        });
    }
    
}

function daysAgo(dateString) {
    const now = new Date();
    const date = new Date(dateString);
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
}

function createTestimonialSlide({initials, name, city, date, title, review, rating = 5}) {
    const stars = Array.from({ length: rating }, () => `<img src="//www.tiesncuffs.com.au/cdn/shop/t/151/assets/icon-star.svg?v=29756938729910241161773205474" alt="Icon Star" />`).join("");

    // Construct the testimonial HTML
    const html = `
        <div class="swiper-slide round-20">
            <div class="testimonials__slide">
                <div class="testimonials__header">
                    <div class="testimonials__header-left">
                        <div class="testimonials__image-container">${initials}</div>
                    </div>
                    <div class="testimonials__header-right">
                        <p><strong>${name}</strong></p>
                        <p class="sm-body">${city} <span>${date}</span></p>
                    </div>
                </div>
                <div class="testimonials__star">
                    ${stars}
                </div>
                <div class="testimonials__slide-heading">
                    <h5>${title}</h5>
                </div>
                <div class="testimonials__slide-content">
                    “${review}”
                </div>
            </div>
        </div>
    `;

    return html.trim();
}

function getInitials(name) {
    return name
        .split(" ")
        .filter(Boolean)
        .map(word => word[0].toUpperCase())
        .join("");
}

async function getFeefoServiceReviews(merchantId, limit = 10) {

    const serviceReviewContainer = document.querySelector(".js-testimonials-container") || "";

    if (!serviceReviewContainer) {
        return;
    }
    
    const url = `https://api.feefo.com/api/10/reviews/service?merchant_identifier=${merchantId}&page_size=${limit}&sort=desc`;
    const res = await fetch(url);
    const data = await res.json();

    
    data.reviews.forEach(r => {
        const service = r.service;

        const thisTitle = service.title || "";
        const desc = service.review || "";
        const thisRating = service.rating.rating;
        const date = service.created_at;
        const city = r.customer?.display_location || "N/A";
        const thisName = r.customer?.display_name || "NA";
        let thisInitials = getInitials(thisName);

        if (thisName === "NA") thisInitials = "NA";

        const thisDate = daysAgo(date);

        const slideHTML = createTestimonialSlide({
            initials: thisInitials,
            name: thisName,
            city: city,
            date: thisDate,
            title: thisTitle,
            review: desc,
            rating: thisRating
        });

        document.querySelector(".js-testimonials-container").insertAdjacentHTML("beforeend", slideHTML);
    });
}

const initSearch = () => {
    const searchBtns = document.querySelectorAll('.js-btn-search');
    const searchBoxes = document.querySelectorAll('.js-search-box');

    searchBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            const searchBox = btn.closest('.bottom-nav__search-wrap').querySelector('.js-search-box');
            const isActive = searchBox.classList.contains('is-active');

            // Close all search boxes first
            searchBoxes.forEach(box => box.classList.remove('is-active'));

            if (!isActive) {
                searchBox.classList.add('is-active');
                setTimeout(() => {
                    searchBox.querySelector('.bottom-nav__search-input').focus();
                }, 50);
            }
        });
    });

    // Close search box when clicking outside
    document.addEventListener('click', e => {
        if (!e.target.closest('.bottom-nav__search-wrap')) {
            searchBoxes.forEach(box => box.classList.remove('is-active'));
        }
    });
};

document.addEventListener("DOMContentLoaded", function() {
    // Search
    initSearch();

    // Navigation
    initNavigation();

    // Logo carousel
    renderLogoCarousel();

    // Corporate Gallery
    renderCorporateGallery();

    // Custom Quote Products Carousel
    renderCustomQuoteProductsCarousel();

    // Custom Quote Form Slider
    renderCustomQuoteFormSlider();

    // Testimonial Slider
    renderTestimonialSlider();

    // Input Form slider
    renderFontSlider();

    // Accordion
    initAccordion();
    
    // FAQ Tab
    initFAQTab();

    // Video player
    initVideoPlayer();

    // product listing - now using server-side Liquid rendering
    // initProductListing();

    // Tabs
    initTabs();

    // Single Product Script
    initSingleProduct();

    // Cart
    cartInit();

    // Select dropdown
    customSelectInit();

    // make cards clickable
    clickableCard();

    // Input file prop
    initInputFile();

    // Feefo
    getFeefoSummary("ties-n-cuffs");
    getFeefoServiceReviews("ties-n-cuffs");

    // Popup
    initPopup();

    // DPO Price Loading State
    initDPOPriceLoading();

    // Add to cart loading state
    // initAddToCartLoading();
});

/**
 * Handle add to cart button loading state using event delegation
 */
function initAddToCartLoading() {
    document.addEventListener('click', e => {
        const form = e.target.closest('.single-product__add-to-cart');
        if (form) {
            form.classList.add('is-loading');
        }
    });
}

/**
 * Remove loading state from price once DPO updates it from $1.00 placeholder
 * Also syncs DPO price changes to the product form price display
 */
function initDPOPriceLoading() {
    const priceElement = document.querySelector('#product .price.js-displayed-price');
    if (!priceElement) return;

    const formPriceEl = document.querySelector('.js-product-form-container .js-variant-price');

    // Watch for price changes and remove loading class when price is updated
    const observer = new MutationObserver(() => {
        const priceText = priceElement.textContent || priceElement.innerText;
        if (!priceText.includes('$1.00')) {
            priceElement.classList.remove('price--loading');

            // Sync DPO price to product form price display
            if (formPriceEl) {
                formPriceEl.textContent = priceText.trim();
                formPriceEl.classList.remove('price--loading');
            }
        }
    });

    observer.observe(priceElement, {
        childList: true,
        characterData: true,
        subtree: true
    });
}

/**
 * Product Form Variant Selector
 * Handles variant switching, price updates, and availability states
 */
function initProductFormVariants() {
    const formContainer = document.querySelector('.js-product-form-container');
    if (!formContainer) return;

    const productJsonEl = formContainer.querySelector('.js-product-json');
    if (!productJsonEl) return;

    let product;
    try {
        product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
        console.error('Failed to parse product JSON:', e);
        return;
    }

    const variantSelects = formContainer.querySelectorAll('.js-variant-option');
    if (variantSelects.length === 0) return;

    const variantIdInput = formContainer.querySelector('.js-variant-id');
    const priceEl = formContainer.querySelector('.js-variant-price');
    const comparePriceEl = formContainer.querySelector('.js-variant-compare-price');
    const priceContainer = formContainer.querySelector('.js-product-form-price');
    const addToCartBtn = formContainer.querySelector('.js-add-to-cart-btn');
    const addToCartText = formContainer.querySelector('.js-add-to-cart-text');

    // Format money helper
    function formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        return `$${amount} AUD`;
    }

    // Get current selected options
    function getSelectedOptions() {
        const options = [];
        variantSelects.forEach(select => {
            options.push(select.value);
        });
        return options;
    }

    // Find variant by selected options
    function findVariant(selectedOptions) {
        return product.variants.find(variant => {
            return selectedOptions.every((option, index) => {
                return variant.options[index] === option;
            });
        });
    }

    // Update form based on selected variant
    function updateForm(variant) {
        if (!variant) {
            // No matching variant - unavailable
            if (variantIdInput) variantIdInput.value = '';
            if (addToCartBtn) {
                addToCartBtn.disabled = true;
                if (addToCartText) addToCartText.textContent = 'Unavailable';
            }
            if (priceContainer) priceContainer.classList.add('product-form-price--unavailable');
            return;
        }

        // Update variant ID
        if (variantIdInput) variantIdInput.value = variant.id;

        // Update price
        if (priceEl) {
            priceEl.textContent = formatMoney(variant.price);
        }

        // Update compare at price
        if (comparePriceEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                comparePriceEl.textContent = formatMoney(variant.compare_at_price);
                comparePriceEl.style.display = '';
            } else {
                comparePriceEl.style.display = 'none';
            }
        }

        // Update availability
        if (priceContainer) {
            priceContainer.classList.remove('product-form-price--unavailable');
        }

        if (addToCartBtn) {
            if (variant.available) {
                addToCartBtn.disabled = false;
                if (addToCartText) addToCartText.textContent = 'Add to Cart';
            } else {
                addToCartBtn.disabled = true;
                if (addToCartText) addToCartText.textContent = 'Sold Out';
            }
        }

        // Update quantity input max based on inventory
        const quantityInput = formContainer.querySelector('.js-quantity-input');
        if (quantityInput) {
            const inventoryPolicy = variant.inventory_policy;
            const inventoryManagement = variant.inventory_management;
            const inventoryQuantity = variant.inventory_quantity;

            // If no inventory management or policy allows overselling, remove max
            if (!inventoryManagement || inventoryPolicy === 'continue') {
                quantityInput.removeAttribute('max');
            } else if (inventoryQuantity > 0) {
                quantityInput.setAttribute('max', inventoryQuantity);
                // Reset quantity if current value exceeds new max
                if (parseInt(quantityInput.value) > inventoryQuantity) {
                    quantityInput.value = inventoryQuantity;
                }
            } else {
                quantityInput.setAttribute('max', 1);
                quantityInput.value = 1;
            }
        }

        // Update URL without page reload
        if (history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            history.replaceState({}, '', url);
        }

        // Dispatch custom event for other scripts that might need to know
        formContainer.dispatchEvent(new CustomEvent('variant:changed', {
            detail: { variant: variant }
        }));
    }

    // Listen for option changes
    variantSelects.forEach(select => {
        select.addEventListener('change', () => {
            const selectedOptions = getSelectedOptions();
            const variant = findVariant(selectedOptions);
            updateForm(variant);
        });
    });

    // Check URL for variant parameter on load
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam) {
        const variant = product.variants.find(v => v.id === parseInt(variantParam));
        if (variant) {
            // Set select values to match URL variant
            variant.options.forEach((option, index) => {
                if (variantSelects[index]) {
                    variantSelects[index].value = option;
                }
            });
            updateForm(variant);
        }
    }
}

const initDescriptionClamp = () => {
    const clampContainers = document.querySelectorAll('.js-description-clamp');

    clampContainers.forEach(container => {
        const content = container.querySelector('.description-clamp__content');
        const toggle = container.querySelector('.js-description-toggle');

        if (!content || !toggle) return;

        // Check if content is actually clamped (overflowing)
        const checkClamped = () => {
            // Temporarily remove clamp to measure full height
            const originalDisplay = content.style.display;
            const originalWebkitLineClamp = content.style.webkitLineClamp;
            const originalOverflow = content.style.overflow;

            content.style.display = 'block';
            content.style.webkitLineClamp = 'unset';
            content.style.overflow = 'visible';
            const fullHeight = content.scrollHeight;

            content.style.display = originalDisplay || '';
            content.style.webkitLineClamp = originalWebkitLineClamp || '';
            content.style.overflow = originalOverflow || '';
            const clampedHeight = content.clientHeight;

            if (fullHeight > clampedHeight + 5) {
                container.classList.add('clamped');
            } else {
                container.classList.remove('clamped');
            }
        };

        checkClamped();

        toggle.addEventListener('click', () => {
            const isExpanded = container.classList.contains('expanded');

            if (isExpanded) {
                container.classList.remove('expanded');
                toggle.textContent = 'View More';
            } else {
                container.classList.add('expanded');
                toggle.textContent = 'View Less';
            }
        });
    });
};

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', initProductFormVariants);
document.addEventListener('DOMContentLoaded', initDescriptionClamp);